import { useContainer } from '../../useContainer';
import { ClientApi, ToastStateHandler } from '../../../api';
import { useTranslation } from '../../useTranslation';
import { PostTermsDto } from '../../../commonTypes/client.types';
import { AppError, getUserMessage } from '../../../api/utils/ErrorHandler';

interface ExecPostOptions {
    onSuccess?: () => void;
}

const useHttpPostPaymentTerms = () => {
    const { t } = useTranslation('newNotifications');
    const clientApi: ClientApi = useContainer(ClientApi);
    const toastHandler = useContainer(ToastStateHandler);

    const execPost = (terms: PostTermsDto[], options?: ExecPostOptions) => {
        const { exec, abort } = clientApi.postTerms({
            body: terms,
            onSuccess: () => {
                toastHandler.push('success', t('invoice.termsCreateTitle'), t('invoice.termsCreateSuccess'));
                options?.onSuccess?.();
            },
            onError: (error: AppError | string) => {
                const message = getUserMessage(error, t('invoice.termsCreateError'));
                toastHandler.push('error', t('invoice.termsCreateTitle'), message);
            },
        });
        exec();
        return abort;
    };

    return { execPost };
};

export default useHttpPostPaymentTerms;
